import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {ParamsModel} from 'src/app/modules/common/Model'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload

    yield delay(500)
    const response: ResponseModel = yield call(service.getNabilAuctionSubscriber, params)
    yield put(actions.getNabilAuctionSubscriberSuccess(response?.data?.data))
    yield put(actions.getNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getNabilAuctionSubscriberFinish())
  }
}

function* enableNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableNabilAuctionSubscriber, selectedUsers)
    yield put(actions.enableNabilAuctionSubscriberSuccess(response?.data))
    yield delay(100)
    yield put(actions.enableNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.enableNabilAuctionSubscriberFinish())
  }
}

function* disableNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableNabilAuctionSubscriber, selectedUsers)
    yield put(actions.disableNabilAuctionSubscriberSuccess(response?.data))
    yield delay(100)
    yield put(actions.disableNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.disableNabilAuctionSubscriberFinish())
  }
}

function* singleEnableNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableNabilAuctionSubscriber, selectedUsers)
    yield put(actions.singleEnableNabilAuctionSubscriberSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleEnableNabilAuctionSubscriberFinish())
  }
}

function* singleDisableNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableNabilAuctionSubscriber, selectedUsers)
    yield put(actions.singleDisableNabilAuctionSubscriberSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.singleDisableNabilAuctionSubscriberFinish())
  }
}

function* deleteNabilAuctionSubscriberSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteNabilAuctionSubscriber, body)
    yield put(actions.deleteNabilAuctionSubscriberSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteNabilAuctionSubscriberFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.deleteNabilAuctionSubscriberFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_START, getNabilAuctionSubscriberSaga)
  yield takeLatest(actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_START, deleteNabilAuctionSubscriberSaga)
  yield takeLatest(actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST, enableNabilAuctionSubscriberSaga)
  yield takeLatest(actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST, disableNabilAuctionSubscriberSaga)
  yield takeLatest(actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST, singleEnableNabilAuctionSubscriberSaga)
  yield takeLatest(actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST, singleDisableNabilAuctionSubscriberSaga)
}
